<template>
  <MainViewFrame>
    <div class="companyProduct" ref="contents">
      <div class="products">
        <div class="product" v-for="item in data" :key="item.pk" @click="jumpToWorkDetail(item)">
          <!-- 这个模块只需要购买，不需要下架 
            <span
            v-if="company && company.is_ceo"
            class="takeoff"
            @click.stop="removeProduct(item)"
          >下架</span> -->
          <div
            class="img"
            :style="{ height: `${workHeight}px`, backgroundImage:`url(${getImg(item.showwork.images)})` }"
          >
          </div>
          <div class="text">
            <div class="name">
              <span class="title">{{ item.showwork.name }}</span>
              <span class="sell">已售:{{item.sell_count}}</span>
            </div>
            <div class="priceView">
              <span class="price">价值: {{item.price}}蓝钻</span>
              <span class="buy" v-if="item.is_buy === false" @click.stop="buy(item)">购买</span>
              <span class="bought" v-else>已买</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainViewFrame>
</template>

<script>
import MainViewFrame from "./MainViewFrame.vue";
import { Utils } from "../utils";

//弹出框组件
import { types as ConfirmTypes } from "../store/modules/confirm";
import { types as CompanyTypes } from "../store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "DetailCompanyProduct",
  components: {
    MainViewFrame
  },
  data() {
    return {
      company_id: 0,
      workHeight: 150
    };
  },
  computed: {
    ...mapState({
      page: state => state.company.product_inside.page,
      load_more: state => state.company.product_inside.load_more,
      data: state => state.company.product_inside.data
    })
  },
  methods: {
    ...mapMutations({
      showConfirm: ConfirmTypes.SHOW,
      hideConfirm: ConfirmTypes.HIDE
    }),
    ...mapActions({
      fetchListProduct: CompanyTypes.FETCH_PRODUCT_LIST_INSIDE, //产品列表
      fetchCreateProductOrder: CompanyTypes.FETCH_CREATE_PRODUCT_ORDER, //购买订单
    }),
    ...Utils,

    //  购买产品
    buy(item) {
      var dic = {
        content: "是否确定购买",
        //确定购买
        submitCB: () => {
          this.fetchCreateProductOrder({ pk: item.pk }), this.hideConfirm;
        },
        //取消购买
        cancelCB: () => {
          this.hideConfirm();
        },
        submitText: "确定",
        cancelText: "取消"
      };
      this.showConfirm(dic);
    },

    // 产品详情页
    jumpToWorkDetail(item) {
      let pk = item.showwork.pk;
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${pk}`,
        "_blank"
      );
    },

    //  滚动事件翻页功能
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据");
          that.fetchListProduct({
            page: that.page + 1,
          });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.workHeight = (this.$refs.contents.clientWidth - 30) / 4 - 10 - 2;
    // console.log(this.workHeight)
    this.fetchListProduct({ page: 1 });
  }
};
</script>

<style lang="less" scoped>
.companyProduct {
  background-color: #f6f6f6;
  padding: 15px;
  border-radius: 8px;
  .products {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
    .product {
      background-color: #ffffff;
      border: solid 1px #ebebeb;
      margin-right: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      width: calc(100% / 4 - 12px);
      position: relative;
      .takeoff {
        position: absolute;
        left: 0;
        top: 10px;
        padding: 2px 7px;
        padding-right: 10px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
        background-color: #541dff;
        color: #ffffff;
        font-size: 11px;
        cursor: pointer;
      }
      .img {
        width: 100%;
        height: 150px;
        background-color: #e1e1e1;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .text {
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 12px;
        .name {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .title {
            color: #2d2d2d;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            flex: 1;
            margin-right: 10px;
          }
          .sell {
            color: #666666;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
          }
        }
        .priceView {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 5px;
          margin-bottom: 10px;
          align-items: center;
          .price {
            color: #2d2d2d;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            flex: 1;
            margin-right: 10px;
          }
          .buy {
            padding: 2px 10px;
            border-radius: 15px;
            background-color: #f56501;
            color: #ffffff;
          }
          .bought {
            padding: 2px 10px;
            border-radius: 15px;
            background-color: #e1e1e1;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
